export const SUMMIT = {
  name: "THE CHOICE",
  tagline: "Detroit's Health, Wellness, Innovation & Investment Summit",
  host: "The Edutainment Box × DABO",
  dateISO: "2026-10-27T16:00:00-04:00",
  dateLabel: "Tuesday, October 27, 2026",
  timeLabel: "4:00 PM – 7:00 PM EDT",
  programLabel: "4:00–5:00 PM Meet & Greet · 5:00–7:00 PM Summit Program",
  venue: "LaVonne M. Sheffield Library / Bridge Center",
  address: "9928 Grand River Avenue",
  city: "Detroit, Michigan 48204",
  contactName: "Joan L. Washington",
  contactEmail: "edugreenjlw@gmail.com",
  contactPhone: "248-881-8770",
  videoEmbedUrl: "",
  videoUrl: "/assets/video-invitation.mp4",
  calendarUrl:
    "https://calendar.google.com/calendar/render?action=TEMPLATE&text=The%20Choice%20%E2%80%94%20Detroit's%20Health%2C%20Wellness%2C%20Innovation%20%26%20Investment%20Summit&dates=20261027T200000Z/20261027T230000Z&location=LaVonne%20M.%20Sheffield%20Library%20%2F%20Bridge%20Center%2C%209928%20Grand%20River%20Avenue%2C%20Detroit%2C%20MI%2048204&details=VVIP%20invite-only%20summit%20presented%20by%20The%20Edutainment%20Box%20in%20collaboration%20with%20DABO",
};

export const HERO_SLIDES = [
  {
    image: "/assets/hero-sunrise.jpg",
    kicker: "Presented by The Edutainment Box × DABO",
    lines: ["THE CHOICE"],
    sub: "Detroit's Health, Wellness, Innovation & Investment Summit — a VVIP gathering where Global Detroit meets South African smart technology.",
  },
  {
    image: "/assets/hero-dusk.jpg",
    kicker: "VVIP · By Special Invitation Only",
    lines: ["Detroit Has Survived.", "Detroit Has Endured."],
    sub: "Now Detroit has another choice: accessible, digital healthcare — built for Global Detroit.",
  },
  {
    image: "/assets/hero-night.jpg",
    kicker: "MedX AI · Live in Detroit",
    lines: ["30+ Vital Screenings", "In Under 3 Minutes"],
    sub: "Watch our official video invitation — then experience the MedX AI Health & Wellness Kiosk live at the summit.",
    cta: { label: "Watch the Video Invitation", target: "film" },
  },
  {
    image: "/assets/hero-skyline.jpg",
    kicker: "October 27, 2026 · Detroit, Michigan",
    lines: ["Why Wait for Change?", "Detroit Is the Change."],
    sub: "Seats are strictly limited. This invitation does not guarantee admission — reservation confirmation is required.",
  },
];

export const RSVP_COHORTS = [
  "Doctor / Medical Practitioner",
  "Investor",
  "Media Agency",
  "Corporate CEO / Director",
  "VVIP Invitee",
];

export const AUDIENCE = [
  {
    id: "doctors",
    icon: "Stethoscope",
    title: "Doctors",
    text: "Detroit physicians exploring AI-assisted screening and digital care built for the communities they serve.",
  },
  {
    id: "practitioners",
    icon: "HeartPulse",
    title: "Medical Practitioners",
    text: "Clinic and wellness operators seeing the MedX AI Health & Wellness Kiosk deliver 30+ vital screenings in under 3 minutes.",
  },
  {
    id: "investors",
    icon: "LineChart",
    title: "Investors",
    text: "Capital partners backing Detroit's health, wellness and innovation economy — from kiosk networks to smart technology.",
  },
  {
    id: "media",
    icon: "Radio",
    title: "Media Agencies",
    text: "Detroit and international media with front-row access to the announcements shaping Global Detroit.",
  },
  {
    id: "ceos",
    icon: "Briefcase",
    title: "Corporate CEOs & Directors",
    text: "Executive leaders forging Detroit–South Africa partnerships across healthcare, technology and enterprise.",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Honoring the Hardest Hit",
    text: "The Choice honors the Detroit communities hit hardest by COVID-19 — and unveils a bold answer: accessible, digital healthcare, built for Global Detroit.",
  },
  {
    num: "02",
    title: "Detroit × South Africa",
    text: "In partnership with South Africa's Nathaniel Van Zeeberg and his next-generation smart technology, Detroit brings world-class innovation home.",
  },
  {
    num: "03",
    title: "Loss Into a Movement",
    text: "Featuring Samantha “Sammy” Stephenson — the South African entrepreneur behind MedX AI, turning personal loss into a movement for global health equity.",
  },
  {
    num: "04",
    title: "The Choice",
    text: "Why wait for change? Detroit is the change — and knows how to bring it to the table. On October 27, the room decides what comes next.",
  },
];

export const AGENDA = [
  { time: "4:00 PM", title: "Meet & Greet + Light Refreshments", detail: "VVIP arrival, concierge check-in, networking" },
  { time: "5:00 PM", title: "Summit Program Opens", detail: "Welcome by Joan L. Washington — Host & CEO, The Edutainment Box" },
  { time: "5:20 PM", title: "Keynote — The Choice", detail: "Rev. Horace Sheffield III, CEO of DABO Detroit" },
  { time: "5:45 PM", title: "MedX AI Live Demonstration", detail: "Samantha “Sammy” Stephenson, President of MEDX AI — 30+ vital screenings in under 3 minutes" },
  { time: "6:15 PM", title: "Global Detroit × South Africa", detail: "Nathaniel Van Zeeberg, CEO of Qfinity Media Group — next-generation smart technology" },
  { time: "6:45 PM", title: "The Choice — Call to Action", detail: "Partnerships, commitments and closing remarks" },
  { time: "7:00 PM", title: "Program Close", detail: "Concierge networking continues" },
];

export const SPEAKERS = [
  {
    id: "joan-washington",
    name: "Joan L. Washington",
    role: "Host & CEO",
    organization: "The Edutainment Box",
    category: "Host",
    image: "/assets/speaker-joan.jpg",
    bio: "Host of The Choice and CEO of The Edutainment Box, Joan L. Washington convenes leaders from Detroit and South Africa to shape what comes next for health, wellness, innovation and investment.",
  },
  {
    id: "rev-horris-sheffield",
    name: "Rev. Horace Sheffield III",
    role: "CEO",
    organization: "DABO Detroit",
    category: "Leadership",
    image: "/assets/speaker-horris.jpg",
    bio: "CEO of DABO Detroit and co-presenter of The Choice, Rev. Sheffield champions community-first development and a Detroit that brings change to the table.",
  },
  {
    id: "samantha-stephenson",
    name: "Samantha Stephenson",
    role: "President",
    organization: "MEDX AI (South Africa)",
    category: "Innovation",
    image: "/assets/speaker-samantha.jpg",
    bio: "“Sammy” Stephenson is the South African entrepreneur behind MedX AI — turning personal loss into a movement for global health equity. She presents the MedX AI Health & Wellness Kiosk live in Detroit.",
  },
  {
    id: "nathaniel-van-zeeberg",
    name: "Nathaniel Van Zeeberg",
    role: "CEO",
    organization: "Qfinity Media Group (South Africa)",
    category: "Technology",
    image: "/assets/speaker-nathanie.jpg",
    bio: "CEO of Qfinity Media Group and South African smart-technology partner of The Choice, Nathaniel bridges next-generation technology and global storytelling.",
  },
];

export const ABOUT_STORY = [
  {
    num: "01",
    title: "A Special Invitation",
    text: "By special invitation only, you are called to Detroit's premier Global Innovation Summit — where leaders from Detroit and South Africa gather to shape what comes next.",
  },
  {
    num: "02",
    title: "Detroit Is the Change",
    text: "Detroit has survived. Detroit has endured. Now Detroit has another choice. Why wait for change? Detroit is the change — and knows how to bring it to the table.",
  },
  {
    num: "03",
    title: "Honoring Our Communities",
    text: "The Choice honors communities hit hardest by COVID-19 and unveils a bold vision: accessible, digital healthcare — built for Global Detroit, in partnership with South Africa's Nathaniel Van Zeeberg and next-generation smart technology.",
  },
  {
    num: "04",
    title: "A Movement for Health Equity",
    text: "Featuring Samantha “Sammy” Stephenson, the South African entrepreneur behind MedX AI — turning personal loss into a movement for global health equity, with 30+ vital screenings delivered in under 3 minutes.",
  },
];
